export const YOU_TUBE_URL_REGEX = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;
/*
const REGEX = /(?:https?:\/\/)?(?:youtu\.be\/|(?:www\.|m\.)?youtube\.com\
/(?:watch|v|embed)(?:\.php)?(?:\?.*v=|\/))([a-zA-Z0-9_-]+)/;
*/

/**
 * Checks if a given string is a valid youtube url.
 * @param value Url string to check
 * @returns boolean indicating if value is a valid youtube url.
 */
export const isYoutubeUrl = (value: string) => {
  const regExp = YOU_TUBE_URL_REGEX;
  const match = value.match(regExp);
  return !!(match && match[2].length === 11);
};

/**
 * Extracts a youtube id from a given string
 * @param value Youtube Video Id
 * @returns extracted youtube id as string or null if input is invalid youtube url
 */
export const extractYoutubeId = (value: string) => {
  if (isYoutubeUrl(value)) {
    const match = value.match(YOU_TUBE_URL_REGEX);
    return match[2];
  }
  return null;
};

export default { isYoutubeUrl };
